export default __webpack_public_path__ + "static/media/INFOGROUP.962913e3.png";